import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import {
  IState,
  ISuccessAction,
  IFailureAction,
} from "interfaces/paginate-duck";
import { IOrderFOB } from "interfaces/order-fob";

const { Types, Creators } = createActions(
  {
    request: ["query"],
    success: ["data", "pagination"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "PAGINATE_ORDERS_FOB" }
);

export interface PaginateOrdersFOBState extends IState {
  data: IOrderFOB[];
}

const INITIAL_STATE: PaginateOrdersFOBState = {
  data: [],
  pagination: null,
  loading: false,
  error: null,
};

const request = (state: PaginateOrdersFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: PaginateOrdersFOBState, action: ISuccessAction) => 
  update(state, {
    data: { $set: action.data as IOrderFOB[] },
    pagination: { $set: action.pagination },
    loading: { $set: false },
  });

const failure = (state: PaginateOrdersFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const paginateOrdersFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const PaginateOrdersFOBTypes = Types;
export const PaginateOrdersFOBActions = Creators;
